// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__oCUoY","addWidgetButton":"Header_addWidgetButton__1U0cT","dashboardTabs":"Header_dashboardTabs__3-WLh","active":"Header_active__3GMV6"};